module.exports = __webpack_public_path__ + "images/05_48e9ea1e.png";